export class Event {
    constructor(type, params) {
        this.type = type;
        this.params = params || null;
    }
    getParams() {
        return this.params;
    }
    getType() {
        return this.type;
    }
}
Event.DISK_POCKETED = "disk pocketed";
Event.TURN_COMPLETED = "turn completed";
Event.CONTACT_DISK_DISK = "contact disk disk";
Event.CONTACT_DISK_BORDER = "contact disk border";
// used while developing
Event.DRAW_LINE = "draw line";
Event.DRAW_CIRCLE = "draw circle";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2V2ZW50cy9FdmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sS0FBSztJQWNkLFlBQVksSUFBWSxFQUFFLE1BQVk7UUFFbEMsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLElBQUksSUFBSSxDQUFDO0lBQ2pDLENBQUM7SUFFTSxTQUFTO1FBRVosT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7SUFFTSxPQUFPO1FBRVYsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDO0lBQ3JCLENBQUM7O0FBMUJzQixtQkFBYSxHQUFHLGVBQWUsQ0FBQztBQUNoQyxvQkFBYyxHQUFHLGdCQUFnQixDQUFDO0FBQ2xDLHVCQUFpQixHQUFHLG1CQUFtQixDQUFDO0FBQ3hDLHlCQUFtQixHQUFHLHFCQUFxQixDQUFDO0FBRW5FLHdCQUF3QjtBQUNELGVBQVMsR0FBRyxXQUFXLENBQUM7QUFDeEIsaUJBQVcsR0FBRyxhQUFhLENBQUMifQ==